
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore } from "@/store/store-accessor";
import Icon from "@/components/UI/Icon.vue";
import { LoggedOutErrorNotification } from "@/types/notifications";
@Component({
  components: { Icon }
})
export default class LoggedOutError extends Vue {
  @Prop()
  value!: LoggedOutErrorNotification;

  get loginURL(): string | undefined {
    return configStore.neededData?.adminLoginUrl;
  }

  clear() {
    this.$emit("clear");
  }
}
